'use client'

import Image from 'next/image'

import { cn } from '@src/utils/tailwind'

import errorIcon from './modules/error.svg'
import successIcon from './modules/success.svg'
import warningIcon from './modules/warning.svg'

const icons = {
  success: successIcon,
  warning: warningIcon,
  error: errorIcon,
}

export interface ToastProps {
  message: string
  variant: 'success' | 'warning' | 'error'
}

export function Toast({ message, variant }: ToastProps) {
  return (
    <div
      className={cn('flex items-center gap-[10px] rounded-lg p-4 font-medium', {
        'bg-[#E2EDEB] text-bodi-green-deep-600': variant === 'success',
        'bg-[#F5EEC8] text-[#9B6500]': variant === 'warning',
        'bg-[#FBD5D5] text-[#BE4340]': variant === 'error',
      })}
    >
      <Image
        className="size-7"
        width={28}
        height={28}
        alt={`${variant} toast icon`}
        src={icons[variant]}
      />
      {message}
    </div>
  )
}
